export default __webpack_public_path__ + "8dbeb0ea6cd5f1f5cf6ec094dfbfb96c.ttf";